<template>
<div>
    <v-img :src="require('@/assets/maya/servicios/headers/gp12.jpg')" max-height="420" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                GP12
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-regular" style="max-width:480px; line-height:1.3">
                <div>Contención Temprana de Producción</div>
            </div>

            <div>
                <v-btn small text class="white--text ml-n4 mt-2" @click="$router.push('/servicios')">
                    <div class="d-flex align-center">
                        <v-icon size="12" color="white" class="mr-2 mt-1">fa-arrow-left</v-icon>
                        <div>Regresar a servicios</div>
                    </div>
                </v-btn>
            </div>
        </v-card>
    </v-img>

    <div class="white py-6 px-4 px-sm-0">
        <v-row class="">
            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="1">
                <p>
                    <span class="primary--text font-weight-bold">Con los servicios GP-12, conocidos también como Servicios de Contención Temprana,</span> nos enfocamos en el desarrollo de productos de calidad sobresaliente. Es una herramienta que ofrece una garantía de alta calidad pues inspecciona que no exista ninguna falla durante las etapas de pruebas, de pre-producción y de producción.
                </p>

                <p>
                    El servicio GP12 va de la mano con un plan de contención para poder detectar problemas de calidad oportunamente, y no cuando los errores llegan a manos del cliente final. 
                </p>

                <div class="mt-4 primary--text font-weight-bold">Ofrecemos:</div>
                <ul>
                    <li>Identificar y corregir cualquier problema de calidad y detectar áreas de riesgo.</li>
                    <li>Desarrollar planes de lanzamiento seguro, y de pre producción.</li>
                    <li>Desarrollar planes de control de producción.</li>
                    <li>Actualizar, en caso de ser necesario, el plan de control y de calidad avanzado de nuestros clientes: GM, VALEO, THYSSENKRUPP, AUTOLIV, ASSOCIATED SPRING, ADVALTECH, EPMP, BRP.</li>
                    <li>Criterios de salida del Programa de Contención GP-12 una vez que se asegura que los problemas de calidad han sido controlados y resueltos satisfactoriamente.</li>
                    <li>Mejora en los planes de producción por lo que los productos finales cumplen con las expectativas del cliente.</li>
                </ul>

                <p class="mt-4">
                    La contención temprana trae como consecuencia una mejora en todos los procesos.  Así, podemos integrar controles adicionales y auditorías de inspección que nos ayudarán a realizar pruebas precisas.  La idea es saber oportunamente qué medidas tomar y evitar a toda costa las inconformidades.
                </p>
            </v-col>
        </v-row>
    </div>

    <!-- CONTACT FORM -->
    <ContactForm />
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        ContactForm
    },
    metaInfo: {
      title: 'GP12'
    }
}
</script>
